/**
 * UUID Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const UuidDetector: ITypeDetector = {
  id: 'uuid-detector',
  name: 'UUID Detector',
  priority: 90,
  detectedType: SEMANTIC_TYPES.UUID,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    
    // Standard UUID format: 8-4-4-4-12 hexadecimal digits
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    
    if (uuidRegex.test(trimmed)) {
      return SEMANTIC_TYPES.UUID;
    }

    // Also accept UUID without dashes
    const uuidNoDashRegex = /^[0-9a-f]{32}$/i;
    if (uuidNoDashRegex.test(trimmed)) {
      return SEMANTIC_TYPES.UUID;
    }

    return null;
  },
};
